export const toTitleCase = (str: string) => {
  const words = str.includes('_') ? str.split('_') : str.split(' ');
  return words.map((w: string) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};
